
<div *ngIf="control == null">null control.</div>

<div *ngIf="control && control.getError(errorType) && submitted" class="e-error">
    {{ errorMessage }}
</div>